// import Vue from "vue";
import store from "@/store/";
// import config from "@/config/baseConfig";
import {
  USERINFO,
  WECHATUSERINFO,
  COMPANYCODE,
  RESTARUANTINFO,
} from "@/store/mutation-types";
import { ls } from "@/utils//cache";

export default function Initializer() {
  const userInfo = ls.get(USERINFO);
  store.commit("SET_INFO", userInfo);
  const wechatInfo = ls.get(WECHATUSERINFO);
  store.commit("SET_WECHATUSERINFO", wechatInfo);

  const companyCode = ls.get(COMPANYCODE);
  store.commit("SET_COMPANYCODE", companyCode);

  const resInfo = ls.get(RESTARUANTINFO);
  store.commit("SET_RESTARUANTINFO", resInfo);

  const host = location.host;
  const appConfig = versionConfig.appConfig
    ? versionConfig.appConfig[host]
    : {};
  store.commit("SET_APPCONFIG", appConfig || {});
}
